var els = $('#reviews');
if (els.length > 0) {
  require.ensure('../reviews/reviews', function(require) {
    var Reviews = require('../reviews/reviews');
    els.each(function() {
      return new Reviews(this);
    });
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/reviews.initializer.js